export default __webpack_public_path__ + "static/banner_back-4503be3580e172fab9075f6be147f4ad.webp";